import { createSlice } from "@reduxjs/toolkit";
import flagsInfo from "../../assets/countries.json";

const initialState = {
  countries: [],
  flagsInfo,
};

export const countriesSlice = createSlice({
  name: "countries",
  initialState,
  reducers: {
    updatecountriesSlice: (state, action) => {
      state.countries = action.payload;
    },
  },
});

// Action creators are generated for each case reducer function
export const { updatecountriesSlice } = countriesSlice.actions;
export default countriesSlice.reducer;
